import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalService } from '../core';
import { GlobalNamespace as _GlobalNS,  environment } from '../../environments/environment';
import { listPriceHistory } from './propertyChangeLog';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class propertyChangeLogService {
  
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };
  constructor(private _http: HttpClient, private _global: GlobalService) { }

  // service to retrieve Change Log data based on object ID
  find(objectId: Number): Observable<listPriceHistory[]> {
    const api = (<any>_GlobalNS).api.property.changeLog;
    const params = new HttpParams().set('propertyID', objectId.toString());
    return this._http.get<any>(`${api}`, {params}).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }

}
